module.exports = new __parcel__URL__("empty-cannot-load-item.cb94d607.svg").toString();